export default __webpack_public_path__ + "static/media/ksi-logo.db005844.png";